import React from "react";
import { useTranslation } from "react-i18next";
import MessagesContainer from "../../../components/chat/MessagesContainer";
type ChatListPageProps = {
  classStyles?: string;
  getUser: any;
  setActiveConversation: any;
  activeConversation: any;
  conversations: any;
  setShowChatList: () => void;
  setShowContactList: () => void;
};
export default function ChatListPage(props: ChatListPageProps) {
  const {
    activeConversation,
    setActiveConversation,
    getUser,
    conversations,
    setShowChatList,
    setShowContactList,
  } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.chat",
  });
  return (
    <div className="flex flex-col w-full h-full">
      <MessagesContainer
        classStyles={"max-h-full"}
        setActiveConversation={setActiveConversation}
        activeConversation={activeConversation}
        userList={conversations}
        getUser={getUser}
        setShowChatList={setShowChatList}
      />
      <div className="bg-white mt-auto w-full flex justify-center items-center px-4 pt-4 pb-6 md:px-6">
        <button
          type="button"
          onClick={() => {
            setShowContactList();
          }}
          className="text-gray-700  flex justify-center items-center h-9 w-full py-2 text-sm font-medium bg-white border border-gray-300 rounded-md shadow "
        >
          {t("viewContacts")}
        </button>
      </div>
    </div>
  );
}
